import { editorAPI } from "@/services/api";
import Vue from "vue";
import VueI18n from "vue-i18n";

export const IRENT_LOCALES = ["en", "de", "es", "fr", "hr", "id", "it", "nl", "no", "pl", "pt", "ru", "sv"];

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: "en",
  fallbackLocale: "en",
  messages: {},
});

export async function setLocale(i18n: VueI18n, locale: string) {
  const localMessage = await loadLocaleMessage(locale);
  i18n.setLocaleMessage(locale, localMessage || {});
  i18n.locale = locale;
}

async function loadLocaleMessage(locale: string) {
  try {
    const response = await editorAPI.get(`/v1/translations/${locale}`);
    return response.data;
  } catch (e) {
    return {};
  }
}

export default i18n;
